import { z } from 'zod';
import { emailSchema } from './common';

/**
 * Auth-формы — login (email + password) и magic-link (email-only).
 *
 * Поведение совпадает с frontend-vite/src/pages/auth/login.tsx до zod-рефактора:
 * - PasswordLoginForm: email обязателен; password обязателен (min 1)
 * - MagicLinkForm: только email
 *
 * Backend min-длина пароля не известна на frontend (legacy AntD-форма тоже
 * без min). Если backend reject'ит за длину — server-error показывается
 * через отдельный <Alert> (тот же канал что для ApiError).
 */

export const loginPasswordSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, 'Пароль обязателен'),
});
export type LoginPasswordForm = z.infer<typeof loginPasswordSchema>;

export const magicLinkSchema = z.object({
  email: emailSchema,
});
export type MagicLinkForm = z.infer<typeof magicLinkSchema>;
